import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import RSSB_LOGO from "../assets/RSSB_LOGO.jpeg";
import Swal from "sweetalert2";
import moment from "moment";
import '../styles/noPrint.css';

const PreviewExternalReceiptVoucher = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  const personId = searchParams.get("personId");
  const navigate = useNavigate();
  const id = location.state?.id || searchParams.get('voucherId');
  const receiptData = location.state?.data;

 const [isSubmitting, setIsSubmitting] = useState(false);
  const [data, setData] = useState({});
  const [rowData, setRowData] = useState({});
  const token = localStorage.getItem("token");
  const centerCode = localStorage.getItem("code");
  const sewadarId = localStorage.getItem('sewadarId');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/getReceiptVouchersById/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setRowData(response.data[0]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    const fetchCenterInfo = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/centerInfoForDC`, {
          params: { code: centerCode },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setData(response.data[0]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchCenterInfo();
  }, []);

  if (!rowData) return <p>No data available. Please go back to the list.</p>;

  const getApprovalSummary = () => {
    const summaryMap = new Map();
    rowData?.items?.forEach((item) => {
      const key = `${item.departmentName}|${item.approvedByName}`;
      if (!summaryMap.has(key)) {
        summaryMap.set(key, {
          departmentName: item.departmentName,
          approvedByName: item.approvedByName,
          approvedAt: item.approvedAt,
          count: 0,
        });
      }
      summaryMap.get(key).count += 1;
    });
    return Array.from(summaryMap.values());
  };

  const approvalSummary = getApprovalSummary();
  const itemDetails = rowData?.items || [];

  const fetchCenterInfo = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/centerInfoForDC`, {
        params: { code: centerCode },
        headers: { 'Authorization': `Bearer ${token}` },
      });

      const center = response.data[0];
      setData(center);

      // if (center?.signature?.data) {
      //   const byteArray = new Uint8Array(center?.signature?.data);
      //   let binary = '';
      //   byteArray.forEach(byte => {
      //     binary += String.fromCharCode(byte);
      //   });
      //   const base64String = window.btoa(binary);
      //   setSignatureUrl(`data:image/jpeg;base64,${base64String}`);
      // }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  return (
    <div
      style={{

        border: "1px solid",
        margin: "15px auto",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        maxWidth: "1100px",
        fontSize: "14px",
      }}
    >
      {/* Header */}
<div className="d-flex align-items-center mb-1">
{/* Back (left) */}
{type !== "external" && (
  <button
    className="btn btn-secondary no-print"
    onClick={() => window.history.back()}
  >
    Back
  </button>
)}

{/* Spacer pushes Print to right */}
<div className="ms-auto">
  {rowData.receiptStatus === "Final" && (
    <button
      className="btn btn-success no-print"
      onClick={() => window.print()}
    >
      Print
    </button>
  )}
</div>
</div>

      <div className="border-bottom border-3" style={{ display: 'grid', gridTemplateColumns: '11% 67% 20%', alignItems: 'left', paddingBottom: '7px' }}>
        <img src={RSSB_LOGO} alt="Logo" style={{ height: '80px' }} />
        <div style={{ textAlign: 'justify', fontSize: '14px' }}>
          <h5 style={{ margin: 0 }}>{data?.name}</h5>
          <p style={{ margin: 0 }}>{data?.addressLine1}</p>
          <p style={{ margin: 0 }}>{data?.addressLine2}</p>
          <p style={{ margin: 0 }}>{data?.addressLine3}</p>
          <p style={{ margin: 0 }}>Contact No: {data.mobile1},{data.mobile2}</p>
        </div>
        <div className="text-end mt-1">
        <span><strong>RV#</strong> {rowData?.rvNo}</span> <br />
        <span><strong>Date:</strong> {rowData?.createdAt ? moment(rowData?.createdAt).format('DD-MMM-YY'):"" }</span>
      </div>
      </div>
      {/* <div className="d-flex justify-content-between">
      <div>
      <img src={RSSB_LOGO} alt="Logo" style={{ height: '80px' }} />
      </div> */}
    
    
     <div className="text-center" style={{fontSize:'20px',fontWeight:'500'}}><span >Receipt</span></div>
     <div className="border-3 border-bottom"></div>
      {/* </div> */}
<div className="row mt-4" style={{ fontSize: "15px" }}>
<span>The following goods are being received from <strong>{rowData?.ledgerName}</strong>,vide document number <strong>{rowData?.documentNo}</strong> dated <strong> {rowData?.documentDate ? moment(rowData.documentDate).format("DD-MMM-YY") : ""}</strong>{rowData?.voucherType !== "DR" && (
  <>
    , on <strong>
      {rowData?.entryDate
        ? moment(rowData.entryDate).format("DD-MMM-YY")
        : ""}
      {" "}
      {rowData?.entryTime
        ? moment(rowData.entryTime, "HH:mm:ss").format("hh:mm A")
        : ""}
    </strong>
  </>
)}
</span>
</div>
{/* <div className="mt-3 border-3 border-bottom"></div> */}
      {/* Primary Info */}
      {/* <div className="row mt-4" style={{ fontSize: "15px" }}>
        <span></span>
      <div className="col-3"><strong>Receipt</strong></div>
      <div className="col-3"><strong>Dt:</strong> {rowData?.createdAt ? moment(rowData?.createdAt).format('DD-MMM-YY'):"" }</div> */}
        {/* <div className="col-3"><strong>Doc. No:</strong> {rowData?.documentNo}</div>
        <div className="col-3"><strong>Doc. Dt:</strong> {rowData?.documentDate ? moment(rowData.documentDate).format("DD-MMM-YY") : ""}</div>
        <div className="col-6"> {rowData?.ledgerName}</div> */}
        {/* <div className="col-6"><strong>Vehicle No:</strong> {rowData?.vehicleNo}</div>
        <div className="col-6"><strong>Driver Name:</strong> {rowData?.driverName}</div>
        <div className="col-6"><strong>Mobile No:</strong> {rowData?.driverMobile}</div> */}
        {/* <div className="col-5">
          <strong>Entry:</strong>{" "}
          {rowData?.entryDate ? moment(rowData.entryDate).format("DD-MMM-YY") : ""}{" "}
          {rowData?.entryTime ? moment(rowData.entryTime, "HH:mm:ss").format("hh:mm A") : ""}
        </div> */}
      {/* </div> */}

      {/* Item Table */}
      <h6 className="mt-4 mb-2"></h6>
      <table className="table table-bordered" style={{ fontSize: "14px" }}>
        <thead className="table-light">
          <tr>
            <th>S.No</th>
            <th>Item Description</th>
            <th>Document Qty</th>
            <th>Received Qty</th>
            <th>UOM</th>
          </tr>
        </thead>
        <tbody>
          {itemDetails.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.itemName}</td>
              <td>{Number(item.challanQty) % 1 == 0 ? parseInt(item.challanQty) : parseFloat(item.challanQty).toFixed(2)}</td>
              <td>{Number(item.receivedQty) % 1 == 0 ? parseInt(item.receivedQty) : parseFloat(item.receivedQty).toFixed(2)}</td>
              <td>{item.uom}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div><span>Remarks : <strong>{rowData?.consolidatedRemarks}</strong></span></div>
      <div><span><strong>Note: यह वाउचर विभागीय इंचार्ज द्वारा अनुमोदित किया गया है इसकी इलेक्ट्रॉनिक प्रति मान्य है</strong></span></div>
      <div><span>Prepared By : {rowData?.createdByName ? `${rowData?.createdByName} - ${rowData?.createdByBadge} `:''}</span></div>
      <div>
      <p className="text-end mb-4"  style={{ marginBottom:'7px'}}>Radha Soami Satsang Beas</p>
      <p className="text-end" style={{  fontWeight: 'bold' }}>Authorised Signatory</p>
      </div>
      {/* Print Styles */}
      <style>
        {`
          @media print {
            .no-print {
              display: none !important;
            }
            .footer {
              position: absolute;
              bottom: 0;
              width: 100%;
              page-break-before: always;
            }
          }
        `}
      </style>
    </div>
  );
};

export default PreviewExternalReceiptVoucher;
